import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FaPlus, FaTimes, FaFilter, FaInbox, FaCheck, FaCheckCircle } from "react-icons/fa";
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Pagination from  '../../../components/Pagination/Pagination';
import Moment from 'react-moment';
import { useToasts } from 'react-toast-notifications';
import { API } from 'aws-amplify';
import '../../../styles/compact-filters.css';
import '../../../components/PageHeader/PageHeader.css';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { useI18n } from '../../../i18n';
import './UserList.css';


import { ITEMS_PER_PAGE } from '../../../localdb';

const FILTERS_KEY = "userListFilters";

const UserList = (props) => {
	const { t } = useI18n();
	const [user, setUser] = useState('');
	const [users, setUsers] = useState([]);
	const [contractor, setContractor] = useState();
	const [contractorList, setContractorList] = useState([]);
	const [userList, setUserList] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage] = useState(ITEMS_PER_PAGE);
	const [filtersLoaded, setFiltersLoaded] = useState(false);
	const [usersLoaded, setUsersLoaded] = useState(false);
	const { addToast } = useToasts();
    const params = { 
        headers: {
            'x-api-key': process.env.REACT_APP_API_KEY,        
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    }

	// Load contractors
	useEffect(()=>{ 
		const fetchContractors = async () => {
			
			const contractors = await API.get('settings','/CONTRACTORS', params)
			contractors.values.sort((a, b) => (a > b) ? 1 : -1)

			let list = []
			for (let i = 0; i < contractors.values.length; i++) {
				list.push(<option key={contractors.values[i]} value={contractors.values[i]}>{contractors.values[i]}</option>)
			}

			setContractorList(list);
		}
		fetchContractors();	 
	}, []);

	// Load users
	useEffect(()=>{
		let headerglobal = {
			'x-api-key': process.env.REACT_APP_CITY_API_TOKEN,        
			'Accept': 'application/json',
			'Content-Type': 'application/json'
	}

        const fetchUsers = async () => {
            setIsLoading(true);

            // Build a map of email -> email_verified from Cognito (via backend)
            let verifiedMap = {};
            try {
                const cognitoRes = await API.get('users', '/', params);
                if (cognitoRes && cognitoRes.Users) {
                    cognitoRes.Users.forEach(u => {
                        let email = u.Username;
                        let verified = false;
                        (u.Attributes || []).forEach(attr => {
                            if (attr.Name === 'email' && attr.Value) email = attr.Value;
                            if (attr.Name === 'email_verified') verified = (attr.Value === 'true' || attr.Value === true);
                        });
                        verifiedMap[email] = verified;
                    });
                }
            } catch (e) {
                console.log('Could not load email verified status', e);
            }

						API.get('user_full_list','/'+ process.env.REACT_APP_GLOB_APP_ENV ,{ headers: headerglobal })
							.then(res => {	
								let userList = []; 

									for (let key in res){
									let usr ={}
										usr.username = key;
										usr.contractor = res[key].contractor
										usr.admin = res[key].isAdmin
										usr.name = res[key].name
										usr.date_created = <Moment local format='DD-MM-YYYY' date={ res[key].UserCreateDate } />;
										if (res[key].accountStatus === "true"){
											usr.enabled = true
										} else{
											usr.enabled = false
										}
										usr.status = res[key].UserStatus
										usr.emailVerified = verifiedMap[key] === true
						
										usr.last_upd = <Moment local format='DD-MM-YYYY' date={ res[key].UserUpdateDate } />;
										userList.push(usr);  
									}
									setUserList(userList);   
									setUsers(userList);
									setUsersLoaded(true);
							}) 
							.catch((err) => {
									console.log(err)
									setUsersLoaded(true);
							})
            
 			setIsLoading(false);			
		}
        fetchUsers();	 
	}, []);
	
  	// Restore filters from localStorage on mount
	useEffect(() => {
		const saved = localStorage.getItem(FILTERS_KEY);
		if (saved) {
			const filters = JSON.parse(saved);
			setUser(filters.user || '');
			setContractor(filters.contractor || '');
		}
		setFiltersLoaded(true);
	}, []);

	// Save filters to localStorage whenever they change
	useEffect(() => {
		const filters = {
			user,
			contractor,
		};
		localStorage.setItem(FILTERS_KEY, JSON.stringify(filters));
	}, [user, contractor]);

	// Run handleSearch only when both filtersLoaded and usersLoaded are true
	useEffect(() => {
		if (filtersLoaded && usersLoaded) {
			handleSearch();
		}
	}, [filtersLoaded, usersLoaded, user, contractor]);

	const handleClearSearch = () =>{
		setUser('');
		setContractor('');
		localStorage.removeItem(FILTERS_KEY);
	}

	const handleSearch = () => { 		
		let results = users;

		// User
		if (user){
			results = results.filter(results =>
				results.username.toLowerCase().includes(user.toLowerCase())
		)}

		// contractor
		if (contractor){
			results = results.filter(results =>
				results.contractor.toLowerCase().includes(contractor.toLowerCase())
		)}

		setUserList(results);
		paginate(1);
		
	}

	const handleVerifyEmail = (username) => {
		API.get('user_verify_email', '/' + username, params)
			.then(res => {
				setUsers(prev => prev.map(u => u.username === username ? { ...u, emailVerified: true } : u));
				setUserList(prev => prev.map(u => u.username === username ? { ...u, emailVerified: true } : u));
				addToast(t('toast.emailVerifiedFor', { user: username }), { appearance: 'success' });
			})
			.catch(err => {
				console.log(err);
				addToast(t('toast.errorVerifyingEmail'), { appearance: 'error' });
			});
	}

	
	// Pagination
	  const indexOfLastItem = currentPage * itemsPerPage;
	  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
	  const currentItemList = userList.slice(indexOfFirstItem, indexOfLastItem);
	
	  // Change page
	  const paginate = pageNumber => setCurrentPage(pageNumber);

	const getStatusClass = (status) => {
		if (!status) return 'status-badge';
		const value = status.toUpperCase();
		if (value === 'CONFIRMED') return 'status-badge status-confirmed';
		if (value === 'UNCONFIRMED') return 'status-badge status-pending';
		if (value === 'FORCE_CHANGE_PASSWORD' || value === 'RESET_REQUIRED') return 'status-badge status-warning';
		return 'status-badge';
	};

	return ( 
	<div className="UserList">
	<div>
		<PageHeader
			title={t('pages.users.title')}
			breadcrumbs={[{ label: t('nav.users'), path: '/users' }]}
			count={!isLoading ? userList.length : undefined}
			countLabel={t('common.users')}
			countSingular={t('common.user')}
			actions={
				<Button size="sm" variant="success" onClick={() => { props.history.push('/signup/'); }}>
					<FaPlus /> {t('users.addUser')}
				</Button>
			}
		/>
		
		<div className="row p-0 div-content">
			<div className="col-12 d-flex rounded bg-light p-2 compact-filters">
				<div className="row p-1 w-100">
					<div className="col-12 filters-row filters-row-inline">
					<div className="filters-title-inline">
						<FaFilter /> {t('actions.filters')}
					</div>
					<Form.Group controlId="users" className="filter-field">
						<Form.Label>{t('common.user')}</Form.Label>
						<Form.Control 
							as="input" 
							value={user}
							placeholder={t('users.search')}
							onChange={e => {setUser(e.target.value)}} 
							type="text" />  
					</Form.Group>

					<Form.Group controlId="contractor" className="filter-field">
						<Form.Label>{t('common.contractor')}</Form.Label>
						<Form.Control 
							as="select" 
							value={contractor} 
							onChange={e => {setContractor(e.target.value)}}
						>
							<option value=""></option>
							{contractorList}
						</Form.Control>  
					</Form.Group>
					<Button variant="danger" className="clear-btn" onClick={handleClearSearch} title={t('users.clearFilters')}>
						<FaTimes /> {t('actions.clear')}
					</Button>
					</div>
				</div>
			</div>

			{(!isLoading) ? (
				(currentItemList.length === 0) ? (
					<div className="col-md-12 empty-state">
						<FaInbox className="empty-state-icon" />
						<div className="empty-state-text">{t('users.noRecords')}</div>
						<div className="empty-state-subtext">{t('users.tryFilters')}</div>
					</div>
				):( 
				<div className="col-md-12">
				<Table responsive striped bordered hover variant="light">
				<thead>
					<tr>
					<th>{t('fields.name')}</th>
					<th>{t('fields.email')}</th>
					<th>{t('common.contractor')}</th>
					<th>{t('fields.admin')}</th>
					<th>{t('common.created')}</th>
					<th>{t('fields.updated')}</th>
					<th className="status-col">{t('common.status')}</th>
					<th className="enabled-col">{t('fields.enabled')}</th>
					<th className="verified-col">{t('fields.verified')}</th>
					</tr>
				</thead>
				<tbody>				
				{currentItemList.map((item, i) => (
				<tr key={i}>
					<td className="userName" onClick={() => props.history.push('/user_det/'+ item.username )}>
						{item.name}
					</td>
					<td>{ item.username }</td>
					<td>{ item.contractor }</td>
					<td className="admin-col">
						<span className={(item.admin==='1' || item.admin===1) ? 'admin-badge admin-yes' : 'admin-badge admin-no'}>
							{(item.admin==='1' || item.admin===1) ? t('users.yes') : t('users.no')}
						</span>
					</td>
					<td className="text-nowrap">{ item.date_created }</td>
					<td className="text-nowrap">{ item.last_upd }</td>
					<td className="status-col">
						<span className={getStatusClass(item.status)}>{ item.status }</span>
					</td>
					<td className="enabled-col">
						<span className={item.enabled === true ? 'enabled-badge' : 'disabled-badge'}>
							{item.enabled === true ? t('fields.enabled') : t('fields.disabled')}
						</span>
					</td>
					<td className="verified-col">
						{item.emailVerified === true ? (
							<FaCheckCircle className="verify-tick verified" title={t('users.emailVerified')} />
						) : (
							<button
								type="button"
								className="verify-tick-btn"
								title={t('users.clickVerify')}
								onClick={() => handleVerifyEmail(item.username)}
							>
								<FaCheck />
							</button>
						)}
					</td>
				</tr>
				))}					
				</tbody>
				</Table>		

				<Pagination
					sizePerPage={itemsPerPage}
					currentPage={currentPage}
					totalSize={userList.length}
					changeCurrentPage={paginate}
					theme="bootstrap"
				 />
			</div>

			)):(
				<div className="col-md-12 loading-container">
					<div className="loading-content">
						<Spinner animation="border" role="status" variant="primary" className="loading-spinner" /> 
						<div className="loading-text">{t('users.loading')}</div>
						<div className="loading-subtext">{t('users.pleaseWait')}</div>
					</div>
				</div>
			)}

		</div>
		</div>	
	</div>		
	);

}

const mapStateToProps = state => {
	return {
		user: state.auth.user,
	};
};

export default connect( mapStateToProps )( UserList );
